import get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Search from '../search/search';
import matchMediaDesktop from '../../../utils/client_util';
import featureFlags from '../../../../feature_flags';

export default class Nav extends Component {
  constructor() {
    super();

    this.state = {
      scale: false,
      menu: false,
      search: false
    };

    this.setNavScale = this.setNavScale.bind(this);
    this.getCategoryData = this.getCategoryData.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenuIfOpen = this.closeMenuIfOpen.bind(this);
    this.toggleSearchModal = this.toggleSearchModal.bind(this);
    this.renderCategoryLink = this.renderCategoryLink.bind(this);
    this.renderPageTitle = this.renderPageTitle.bind(this);
  }

  componentDidMount() {
    if (matchMediaDesktop()) {
      window.addEventListener('scroll', this.setNavScale);
    }
  }

  setNavScale() {
    const scrollY = window.scrollY;
    const { scale } = this.state;

    if (this.props.isHome && featureFlags.topNavAdEnabled) {
      this.setState({ scale: false });
    } else {
      if (scale && scrollY <= 20) {
        this.setState({ scale: false });
      }

      if (!scale && scrollY > 20) {
        this.setState({ scale: true });
      }
    }
  }

  getCategoryData(topic) {
    let className = 'nav__link';
    const active = topic.url === get(this.props, 'activeCategory');

    if (active) {
      className = ' nav__active';
    }

    return { className, active };
  }

  setHeaderClass(modifier, menu, isHome) {
    let className = 'page-header';
    if (modifier) {
      className += ` page-header--${modifier}`;
    }
    if (menu) {
      className += ' page-header--menu';
    }

    // For when we have homepage ad, manually add this for now for now
    if (isHome && featureFlags.topNavAdEnabled) {
      className += ' page-header--with-top-ad';
    }
    return className;
  }

  toggleMenu() {
    const { menu } = this.state;
    const html = document.querySelector('html');
    const addRemove = menu ? 'remove' : 'add';
    this.setState({ menu: !menu, search: false });

    html.classList[addRemove]('no-scroll');
  }

  closeMenuIfOpen() {
    if (this.state.menu) {
      this.toggleMenu();
    }
  }

  toggleSearchModal(triggerFocus = true) {
    if (triggerFocus && window.location.pathname.includes('/search')) {
      document.querySelector('.search-form__input--in-page').focus();
      return;
    }

    this.setState({ search: !this.state.search });
  }

  renderCategoryLink(topic) {
    const { url, title, external } = topic;
    const data = this.getCategoryData(topic);
    const attrs = {
      className: data.className,
      title
    };

    if (data.active) {
      return <span {...attrs}>{title}</span>;
    }

    if (external) {
      attrs.href = `//${url}`;
      return <a {...attrs}>{title}</a>;
    }

    attrs.to = url;
    return <Link {...attrs}>{title}</Link>;
  }

  renderPageTitle() {
    const { isHome, modifier, title } = this.props;
    const { scale } = this.state;
    let className = 'page-header__title';

    if (scale) {
      className += ' page-header__title--scaled';
    }

    if (modifier) {
      className += ` page-header__title--${modifier}`;
    }

    if (isHome) {
      return <h2 className={className}>{title}</h2>;
    }

    return <Link to="/" className={className}>{title}</Link>;
  }

  render() {
    const {
      modifier,
      subscribeLink,
      newsletterLink,
      isHome,
      topics,
      env,
      site
    } = this.props;
    const { menu, search, scale } = this.state;

    return (
      <header
        className={this.setHeaderClass(modifier, menu, isHome)}
        onClick={this.closeMenuIfOpen}
      >
        <div className="nav__main-items">
          {this.renderPageTitle()}
          <button
            className={`nav__menu-trigger
              ${scale ? 'nav__menu-trigger--scaled' : ''}`}
            onClick={this.toggleMenu}
          />
          <ul className={`nav__extras ${scale ? 'nav__extras--scaled' : ''}`}>
            <li className="nav__extras-item">
              <a className="nav__newsletter" href={newsletterLink}>
                Newsletter
              </a>
            </li>
            <li className="nav__extras-item">
              <a href={subscribeLink} className="nav__subscribe">Subscribe</a>
            </li>
            <li className="nav__extras-item">
              <button
                className="nav__search-trigger"
                onClick={this.toggleSearchModal}
              >
                <i className="icon-search-glass" />
              </button>
            </li>
          </ul>
        </div>
        <nav className={`nav nav--${modifier}`}>
          <ul className="nav__list">
            {topics.map(topic =>
              <li key={topic.title} className="nav__item">
                {this.renderCategoryLink(topic)}
              </li>
            )}
          </ul>
        </nav>
        <Search
          skin="light"
          modifier="overlay"
          active={search}
          modal={true}
          closeModal={this.toggleSearchModal}
        />
        <MainMenu
          closeMenu={this.toggleMenu}
          mainMenuVisible={menu}
          scaled={this.state.scale}
          site={site}
          {...mainMenuContext}
          env={env}
        />
      </header>
    );
  }
}

Nav.propTypes = {
  isHome: PropTypes.bool.isRequired,
  modifier: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  newsletterLink: PropTypes.string.isRequired,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool, // eslint-disable-next-line react/no-unused-prop-types
      title: PropTypes.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
      url: PropTypes.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
    })
  ).isRequired,
  env: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/nav/nav.js